import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=c37dd9e2&"
import script from "./switch.vue?vue&type=script&lang=js&"
export * from "./switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangbin/workspace/project/bin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c37dd9e2')) {
      api.createRecord('c37dd9e2', component.options)
    } else {
      api.reload('c37dd9e2', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=c37dd9e2&", function () {
      api.rerender('c37dd9e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/switch/switch.vue"
export default component.exports